import React from 'react';
import SubAccountLayout from '../../components/SubAccountLayout';
import { motion } from 'framer-motion';
import { Wrench, Plus, Code, Database, Calendar, FileSpreadsheet } from 'lucide-react';

const FunctionsContent = () => {
  const sampleFunctions = [
    { name: 'Google Sheets', icon: FileSpreadsheet, description: 'Read/write to Google Sheets', color: 'green' },
    { name: 'Google Calendar', icon: Calendar, description: 'Book appointments', color: 'blue' },
    { name: 'Custom API', icon: Code, description: 'Call any REST API', color: 'violet' },
    { name: 'Database', icon: Database, description: 'Query your database', color: 'orange' }
  ];

  return (
    <div className="p-6 md:p-8" data-testid="functions-page">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8"
      >
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl font-display font-semibold text-white mb-1">
              Functions
            </h1>
            <p className="text-gray-400">Create custom tools for your AI agents</p>
          </div>
          <button className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-teal-400 text-space-900 font-medium hover:bg-teal-500 transition-colors">
            <Plus size={18} />
            Create Function
          </button>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8"
      >
        {sampleFunctions.map((fn, idx) => {
          const Icon = fn.icon;
          return (
            <div
              key={fn.name}
              className="glass-card rounded-xl p-5 hover:border-white/20 cursor-pointer transition-all"
            >
              <div className={`w-10 h-10 rounded-lg bg-${fn.color}-400/20 flex items-center justify-center mb-3`}>
                <Icon className={`text-${fn.color}-400`} size={20} />
              </div>
              <h3 className="text-sm font-medium text-white mb-1">{fn.name}</h3>
              <p className="text-xs text-gray-500">{fn.description}</p>
            </div>
          );
        })}
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="glass-card rounded-xl p-12 text-center"
      >
        <Wrench className="mx-auto text-gray-600 mb-4" size={48} />
        <h3 className="text-lg font-medium text-white mb-2">No Custom Functions Yet</h3>
        <p className="text-gray-400 mb-6 max-w-md mx-auto">
          Create functions to give your AI agents the ability to perform actions like booking appointments, 
          updating spreadsheets, or calling external APIs.
        </p>
        <button className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-teal-400 text-space-900 font-medium hover:bg-teal-500 transition-colors">
          <Plus size={18} />
          Create Your First Function
        </button>
      </motion.div>
    </div>
  );
};

const FunctionsPage = () => (
  <SubAccountLayout>
    <FunctionsContent />
  </SubAccountLayout>
);

export default FunctionsPage;
